"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * SR-SSB API
 * SR-SSB REST API suite
 *
 * The version of the OpenAPI document: 3.0
 * Contact: support@separatereality.co.uk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The Message model module.
 * @module model/Message
 * @version 3.0
 */
var Message = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>Message</code>.
   * @alias module:model/Message
   */
  function Message() {
    _classCallCheck(this, Message);
    Message.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(Message, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>Message</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/Message} obj Optional instance to populate.
     * @return {module:model/Message} The populated <code>Message</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new Message();
        if (data.hasOwnProperty('code')) {
          obj['code'] = _ApiClient["default"].convertToType(data['code'], 'String');
        }
        if (data.hasOwnProperty('reasonPhrase')) {
          obj['reasonPhrase'] = _ApiClient["default"].convertToType(data['reasonPhrase'], 'String');
        }
        if (data.hasOwnProperty('message')) {
          obj['message'] = _ApiClient["default"].convertToType(data['message'], 'String');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>Message</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>Message</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['code'] && !(typeof data['code'] === 'string' || data['code'] instanceof String)) {
        throw new Error("Expected the field `code` to be a primitive type in the JSON string but got " + data['code']);
      }
      // ensure the json data is a string
      if (data['reasonPhrase'] && !(typeof data['reasonPhrase'] === 'string' || data['reasonPhrase'] instanceof String)) {
        throw new Error("Expected the field `reasonPhrase` to be a primitive type in the JSON string but got " + data['reasonPhrase']);
      }
      // ensure the json data is a string
      if (data['message'] && !(typeof data['message'] === 'string' || data['message'] instanceof String)) {
        throw new Error("Expected the field `message` to be a primitive type in the JSON string but got " + data['message']);
      }
      return true;
    }
  }]);
}();
/**
 * @member {module:model/Message.CodeEnum} code
 */
Message.prototype['code'] = undefined;

/**
 * @member {String} reasonPhrase
 */
Message.prototype['reasonPhrase'] = undefined;

/**
 * @member {String} message
 */
Message.prototype['message'] = undefined;

/**
 * Allowed values for the <code>code</code> property.
 * @enum {String}
 * @readonly
 */
Message['CodeEnum'] = {
  /**
   * value: "MISSING_CONFIGURATION"
   * @const
   */
  "MISSING_CONFIGURATION": "MISSING_CONFIGURATION",
  /**
   * value: "INITALIAZTION_ERROR"
   * @const
   */
  "INITALIAZTION_ERROR": "INITALIAZTION_ERROR",
  /**
   * value: "ORCHESTRATION_CODE_INVALID"
   * @const
   */
  "ORCHESTRATION_CODE_INVALID": "ORCHESTRATION_CODE_INVALID",
  /**
   * value: "UNSPECIFIED_ERROR"
   * @const
   */
  "UNSPECIFIED_ERROR": "UNSPECIFIED_ERROR",
  /**
   * value: "CONNECTION_TIMEOUT"
   * @const
   */
  "CONNECTION_TIMEOUT": "CONNECTION_TIMEOUT",
  /**
   * value: "SOAP_FAULT"
   * @const
   */
  "SOAP_FAULT": "SOAP_FAULT",
  /**
   * value: "NOT_FOUND"
   * @const
   */
  "NOT_FOUND": "NOT_FOUND",
  /**
   * value: "NOT_CONFIGURED"
   * @const
   */
  "NOT_CONFIGURED": "NOT_CONFIGURED",
  /**
   * value: "DEPRECATED"
   * @const
   */
  "DEPRECATED": "DEPRECATED",
  /**
   * value: "TIMEOUT"
   * @const
   */
  "TIMEOUT": "TIMEOUT",
  /**
   * value: "UNKNOWN_HEADER"
   * @const
   */
  "UNKNOWN_HEADER": "UNKNOWN_HEADER",
  /**
   * value: "AUTHENTICATION_INVALID"
   * @const
   */
  "AUTHENTICATION_INVALID": "AUTHENTICATION_INVALID",
  /**
   * value: "CREDENTIALS_INVALID"
   * @const
   */
  "CREDENTIALS_INVALID": "CREDENTIALS_INVALID",
  /**
   * value: "USER_LOCKED"
   * @const
   */
  "USER_LOCKED": "USER_LOCKED",
  /**
   * value: "AUTHENTICATION_CODY_EXPIRED"
   * @const
   */
  "AUTHENTICATION_CODY_EXPIRED": "AUTHENTICATION_CODY_EXPIRED",
  /**
   * value: "NO_USER_EXISTS"
   * @const
   */
  "NO_USER_EXISTS": "NO_USER_EXISTS",
  /**
   * value: "NO_USERROLE_EXISTS"
   * @const
   */
  "NO_USERROLE_EXISTS": "NO_USERROLE_EXISTS",
  /**
   * value: "NO_USERORGANIZTION_EXISTS"
   * @const
   */
  "NO_USERORGANIZTION_EXISTS": "NO_USERORGANIZTION_EXISTS",
  /**
   * value: "USERNAME_UNAVAILABLE"
   * @const
   */
  "USERNAME_UNAVAILABLE": "USERNAME_UNAVAILABLE",
  /**
   * value: "USER_IS_REG_LOCKED"
   * @const
   */
  "USER_IS_REG_LOCKED": "USER_IS_REG_LOCKED",
  /**
   * value: "MISSING_CUSTOMER"
   * @const
   */
  "MISSING_CUSTOMER": "MISSING_CUSTOMER",
  /**
   * value: "PARAMETER_MISSING"
   * @const
   */
  "PARAMETER_MISSING": "PARAMETER_MISSING",
  /**
   * value: "AUTHENTICATION_ERROR"
   * @const
   */
  "AUTHENTICATION_ERROR": "AUTHENTICATION_ERROR",
  /**
   * value: "DECODING_ERROR"
   * @const
   */
  "DECODING_ERROR": "DECODING_ERROR",
  /**
   * value: "NO_ACCOUNT_EXISTS"
   * @const
   */
  "NO_ACCOUNT_EXISTS": "NO_ACCOUNT_EXISTS",
  /**
   * value: "SERVICE_INVALID"
   * @const
   */
  "SERVICE_INVALID": "SERVICE_INVALID",
  /**
   * value: "NETWORK_UNREACHABLE"
   * @const
   */
  "NETWORK_UNREACHABLE": "NETWORK_UNREACHABLE",
  /**
   * value: "CONNECTION_OTHER"
   * @const
   */
  "CONNECTION_OTHER": "CONNECTION_OTHER",
  /**
   * value: "SERVICE_NO_START_DATE_TIME"
   * @const
   */
  "SERVICE_NO_START_DATE_TIME": "SERVICE_NO_START_DATE_TIME",
  /**
   * value: "PRODUCT_INST_NO_START_DATE_TIME"
   * @const
   */
  "PRODUCT_INST_NO_START_DATE_TIME": "PRODUCT_INST_NO_START_DATE_TIME",
  /**
   * value: "PRODUCT_INST_NO_END_DATE_TIME"
   * @const
   */
  "PRODUCT_INST_NO_END_DATE_TIME": "PRODUCT_INST_NO_END_DATE_TIME",
  /**
   * value: "PRIMARYIDENTIFIER_BELONGS_ON_NETWORK"
   * @const
   */
  "PRIMARYIDENTIFIER_BELONGS_ON_NETWORK": "PRIMARYIDENTIFIER_BELONGS_ON_NETWORK",
  /**
   * value: "ALREADY_REGISTERED"
   * @const
   */
  "ALREADY_REGISTERED": "ALREADY_REGISTERED",
  /**
   * value: "IS_POOLED"
   * @const
   */
  "IS_POOLED": "IS_POOLED",
  /**
   * value: "IS_BLACLKISTED"
   * @const
   */
  "IS_BLACLKISTED": "IS_BLACLKISTED",
  /**
   * value: "SERVICEPLAN_NOT_SUPPORTED"
   * @const
   */
  "SERVICEPLAN_NOT_SUPPORTED": "SERVICEPLAN_NOT_SUPPORTED",
  /**
   * value: "MAX_NUMBER_OF_AUTHCODE_ATTEMPTS"
   * @const
   */
  "MAX_NUMBER_OF_AUTHCODE_ATTEMPTS": "MAX_NUMBER_OF_AUTHCODE_ATTEMPTS",
  /**
   * value: "AUTH_CODE_EXPIRED"
   * @const
   */
  "AUTH_CODE_EXPIRED": "AUTH_CODE_EXPIRED",
  /**
   * value: "MAX_NUMBER_OF_AUTHCODE_SMS_SENDS"
   * @const
   */
  "MAX_NUMBER_OF_AUTHCODE_SMS_SENDS": "MAX_NUMBER_OF_AUTHCODE_SMS_SENDS",
  /**
   * value: "ONE_TIME_PASSCODE_INVALID"
   * @const
   */
  "ONE_TIME_PASSCODE_INVALID": "ONE_TIME_PASSCODE_INVALID",
  /**
   * value: "SEND_SMS_FAIL"
   * @const
   */
  "SEND_SMS_FAIL": "SEND_SMS_FAIL",
  /**
   * value: "SEND_EMAIL_FAIL"
   * @const
   */
  "SEND_EMAIL_FAIL": "SEND_EMAIL_FAIL",
  /**
   * value: "SEND_OTP_FAIL"
   * @const
   */
  "SEND_OTP_FAIL": "SEND_OTP_FAIL",
  /**
   * value: "CONTRACT_INVALID"
   * @const
   */
  "CONTRACT_INVALID": "CONTRACT_INVALID",
  /**
   * value: "ACCOUNT_INVALID"
   * @const
   */
  "ACCOUNT_INVALID": "ACCOUNT_INVALID",
  /**
   * value: "USER_INVALID"
   * @const
   */
  "USER_INVALID": "USER_INVALID",
  /**
   * value: "CUSTOMER_INVALID"
   * @const
   */
  "CUSTOMER_INVALID": "CUSTOMER_INVALID",
  /**
   * value: "CUSTOMER"
   * @const
   */
  "CUSTOMER": "CUSTOMER",
  /**
   * value: "PRODUCTINSTANCE_INVALID"
   * @const
   */
  "PRODUCTINSTANCE_INVALID": "PRODUCTINSTANCE_INVALID",
  /**
   * value: "SERVICEBALANCETRANSFER_INVALID"
   * @const
   */
  "SERVICEBALANCETRANSFER_INVALID": "SERVICEBALANCETRANSFER_INVALID",
  /**
   * value: "CREDITCARD_INVALID"
   * @const
   */
  "CREDITCARD_INVALID": "CREDITCARD_INVALID",
  /**
   * value: "NOPAYMENT_INVALID"
   * @const
   */
  "NOPAYMENT_INVALID": "NOPAYMENT_INVALID",
  /**
   * value: "MOBILEWALLET_INVALID"
   * @const
   */
  "MOBILEWALLET_INVALID": "MOBILEWALLET_INVALID",
  /**
   * value: "PRODUCT_INVALID"
   * @const
   */
  "PRODUCT_INVALID": "PRODUCT_INVALID",
  /**
   * value: "REGISTRATION_INVALID"
   * @const
   */
  "REGISTRATION_INVALID": "REGISTRATION_INVALID",
  /**
   * value: "FILTER_INVALID"
   * @const
   */
  "FILTER_INVALID": "FILTER_INVALID",
  /**
   * value: "BASKET_INVALID"
   * @const
   */
  "BASKET_INVALID": "BASKET_INVALID",
  /**
   * value: "ORDERS_PENDING"
   * @const
   */
  "ORDERS_PENDING": "ORDERS_PENDING",
  /**
   * value: "ORDER_INVALID"
   * @const
   */
  "ORDER_INVALID": "ORDER_INVALID",
  /**
   * value: "CONFIRMED_BASKET_INVALID"
   * @const
   */
  "CONFIRMED_BASKET_INVALID": "CONFIRMED_BASKET_INVALID",
  /**
   * value: "OUTBOUNDCOMMS_INVALID"
   * @const
   */
  "OUTBOUNDCOMMS_INVALID": "OUTBOUNDCOMMS_INVALID",
  /**
   * value: "CONFIRMED_BASKET_CONTENTS_INVALID"
   * @const
   */
  "CONFIRMED_BASKET_CONTENTS_INVALID": "CONFIRMED_BASKET_CONTENTS_INVALID",
  /**
   * value: "CONFIRMED_BASKET_NOT_IN_AWAITING_PAYMENT"
   * @const
   */
  "CONFIRMED_BASKET_NOT_IN_AWAITING_PAYMENT": "CONFIRMED_BASKET_NOT_IN_AWAITING_PAYMENT",
  /**
   * value: "CONFIRMED_BASKET_ALREADY_CONFIRMED"
   * @const
   */
  "CONFIRMED_BASKET_ALREADY_CONFIRMED": "CONFIRMED_BASKET_ALREADY_CONFIRMED",
  /**
   * value: "CONFIRMED_BASKET_IN_PROCESSED"
   * @const
   */
  "CONFIRMED_BASKET_IN_PROCESSED": "CONFIRMED_BASKET_IN_PROCESSED",
  /**
   * value: "USER_DOES_NOT_OWN_BASKET"
   * @const
   */
  "USER_DOES_NOT_OWN_BASKET": "USER_DOES_NOT_OWN_BASKET",
  /**
   * value: "USER_PASSOWRD_MUST_BE_SET"
   * @const
   */
  "USER_PASSOWRD_MUST_BE_SET": "USER_PASSOWRD_MUST_BE_SET",
  /**
   * value: "ENCODING_ERROR"
   * @const
   */
  "ENCODING_ERROR": "ENCODING_ERROR",
  /**
   * value: "PASWD_DECODING_ERROR"
   * @const
   */
  "PASWD_DECODING_ERROR": "PASWD_DECODING_ERROR",
  /**
   * value: "USER_CANNOT_BE_NULL"
   * @const
   */
  "USER_CANNOT_BE_NULL": "USER_CANNOT_BE_NULL",
  /**
   * value: "CATALOG_INVALID"
   * @const
   */
  "CATALOG_INVALID": "CATALOG_INVALID",
  /**
   * value: "CATALOG_NOT_FOUND"
   * @const
   */
  "CATALOG_NOT_FOUND": "CATALOG_NOT_FOUND",
  /**
   * value: "USER_PASSOWRD_STRENGTH_INSUFFICENT"
   * @const
   */
  "USER_PASSOWRD_STRENGTH_INSUFFICENT": "USER_PASSOWRD_STRENGTH_INSUFFICENT",
  /**
   * value: "MAX_PASSWORD_ATTEMPTS"
   * @const
   */
  "MAX_PASSWORD_ATTEMPTS": "MAX_PASSWORD_ATTEMPTS",
  /**
   * value: "BASKET_EMPTY"
   * @const
   */
  "BASKET_EMPTY": "BASKET_EMPTY",
  /**
   * value: "CC_MONTH"
   * @const
   */
  "CC_MONTH": "CC_MONTH",
  /**
   * value: "CC_YEAR"
   * @const
   */
  "CC_YEAR": "CC_YEAR",
  /**
   * value: "PAYMENT_FAIL_TRANSACTION_MISSMATCH"
   * @const
   */
  "PAYMENT_FAIL_TRANSACTION_MISSMATCH": "PAYMENT_FAIL_TRANSACTION_MISSMATCH",
  /**
   * value: "PAYMENT_AUTHORIZATION_INVALID"
   * @const
   */
  "PAYMENT_AUTHORIZATION_INVALID": "PAYMENT_AUTHORIZATION_INVALID",
  /**
   * value: "REFUND_AUTHORIZATION_INVALID"
   * @const
   */
  "REFUND_AUTHORIZATION_INVALID": "REFUND_AUTHORIZATION_INVALID",
  /**
   * value: "BASKET_ADDON_NOT_ALLOWED"
   * @const
   */
  "BASKET_ADDON_NOT_ALLOWED": "BASKET_ADDON_NOT_ALLOWED",
  /**
   * value: "PRODUCT_INSTANCE_NOT_VALID"
   * @const
   */
  "PRODUCT_INSTANCE_NOT_VALID": "PRODUCT_INSTANCE_NOT_VALID",
  /**
   * value: "TOKEN_EXPIRED"
   * @const
   */
  "TOKEN_EXPIRED": "TOKEN_EXPIRED",
  /**
   * value: "TOKEN_INVALID"
   * @const
   */
  "TOKEN_INVALID": "TOKEN_INVALID",
  /**
   * value: "OSSBSS_AUTH_ISSUE"
   * @const
   */
  "OSSBSS_AUTH_ISSUE": "OSSBSS_AUTH_ISSUE",
  /**
   * value: "CC_MAX_FAILED_ATTEMPTS"
   * @const
   */
  "CC_MAX_FAILED_ATTEMPTS": "CC_MAX_FAILED_ATTEMPTS",
  /**
   * value: "ONE_TIME_PASSINVALID"
   * @const
   */
  "ONE_TIME_PASSINVALID": "ONE_TIME_PASSINVALID",
  /**
   * value: "CONTENT_PAGEID_DUPLICATION"
   * @const
   */
  "CONTENT_PAGEID_DUPLICATION": "CONTENT_PAGEID_DUPLICATION",
  /**
   * value: "INBOUNDCOMMS_REF_MISSING"
   * @const
   */
  "INBOUNDCOMMS_REF_MISSING": "INBOUNDCOMMS_REF_MISSING",
  /**
   * value: "NO_INBOUNDCOMMS_EXISTS"
   * @const
   */
  "NO_INBOUNDCOMMS_EXISTS": "NO_INBOUNDCOMMS_EXISTS",
  /**
   * value: "INBOUNDCOMMS_INVALID"
   * @const
   */
  "INBOUNDCOMMS_INVALID": "INBOUNDCOMMS_INVALID",
  /**
   * value: "DATA_SYNCHRONISING"
   * @const
   */
  "DATA_SYNCHRONISING": "DATA_SYNCHRONISING",
  /**
   * value: "CONTENT_PAGE_INVALID"
   * @const
   */
  "CONTENT_PAGE_INVALID": "CONTENT_PAGE_INVALID",
  /**
   * value: "CONTENT_SELECTION_QUERY_INVALID"
   * @const
   */
  "CONTENT_SELECTION_QUERY_INVALID": "CONTENT_SELECTION_QUERY_INVALID",
  /**
   * value: "NO_PAGE_PRODUCT_PAIRING_EXISTS"
   * @const
   */
  "NO_PAGE_PRODUCT_PAIRING_EXISTS": "NO_PAGE_PRODUCT_PAIRING_EXISTS",
  /**
   * value: "PROMOTION_PROCESS_ERROR"
   * @const
   */
  "PROMOTION_PROCESS_ERROR": "PROMOTION_PROCESS_ERROR",
  /**
   * value: "PRODUCT_NOT_CATEGORIZED"
   * @const
   */
  "PRODUCT_NOT_CATEGORIZED": "PRODUCT_NOT_CATEGORIZED",
  /**
   * value: "NO_INVOICE_EXISTS"
   * @const
   */
  "NO_INVOICE_EXISTS": "NO_INVOICE_EXISTS",
  /**
   * value: "INVOICE_INVALID"
   * @const
   */
  "INVOICE_INVALID": "INVOICE_INVALID",
  /**
   * value: "INVOICE_PDF_INVALID"
   * @const
   */
  "INVOICE_PDF_INVALID": "INVOICE_PDF_INVALID",
  /**
   * value: "SERVICE_LIFECYCLE_MISSING"
   * @const
   */
  "SERVICE_LIFECYCLE_MISSING": "SERVICE_LIFECYCLE_MISSING",
  /**
   * value: "SERVICE_NO_PLAN_INSTANCE"
   * @const
   */
  "SERVICE_NO_PLAN_INSTANCE": "SERVICE_NO_PLAN_INSTANCE",
  /**
   * value: "CREATE_DEVICE_CUSTOMER_CANNOT_BE_NULL"
   * @const
   */
  "CREATE_DEVICE_CUSTOMER_CANNOT_BE_NULL": "CREATE_DEVICE_CUSTOMER_CANNOT_BE_NULL",
  /**
   * value: "DEVICE_INVALID"
   * @const
   */
  "DEVICE_INVALID": "DEVICE_INVALID",
  /**
   * value: "PUSH_NOTIFICATION_FAIL"
   * @const
   */
  "PUSH_NOTIFICATION_FAIL": "PUSH_NOTIFICATION_FAIL",
  /**
   * value: "TEMPLATE_INVALID"
   * @const
   */
  "TEMPLATE_INVALID": "TEMPLATE_INVALID",
  /**
   * value: "CALL_DATA_RECORD"
   * @const
   */
  "CALL_DATA_RECORD": "CALL_DATA_RECORD",
  /**
   * value: "SECURITY_CHECK_INVALID"
   * @const
   */
  "SECURITY_CHECK_INVALID": "SECURITY_CHECK_INVALID",
  /**
   * value: "NO_ORGANIZATION_EXISTS"
   * @const
   */
  "NO_ORGANIZATION_EXISTS": "NO_ORGANIZATION_EXISTS",
  /**
   * value: "HIBERNATE_PERSISTENCE_ERROR"
   * @const
   */
  "HIBERNATE_PERSISTENCE_ERROR": "HIBERNATE_PERSISTENCE_ERROR",
  /**
   * value: "ORGANIZATION_INVALID"
   * @const
   */
  "ORGANIZATION_INVALID": "ORGANIZATION_INVALID",
  /**
   * value: "NO_EMPLOYEE_EXISTS"
   * @const
   */
  "NO_EMPLOYEE_EXISTS": "NO_EMPLOYEE_EXISTS",
  /**
   * value: "EMPLOYEE_INVALID"
   * @const
   */
  "EMPLOYEE_INVALID": "EMPLOYEE_INVALID",
  /**
   * value: "DATA_MERGE_ERROR"
   * @const
   */
  "DATA_MERGE_ERROR": "DATA_MERGE_ERROR",
  /**
   * value: "PAYMENT"
   * @const
   */
  "PAYMENT": "PAYMENT",
  /**
   * value: "PERMISSION"
   * @const
   */
  "PERMISSION": "PERMISSION",
  /**
   * value: "OSSBSS_UNKNOWN_ERROR"
   * @const
   */
  "OSSBSS_UNKNOWN_ERROR": "OSSBSS_UNKNOWN_ERROR",
  /**
   * value: "REPEATED_ORDER"
   * @const
   */
  "REPEATED_ORDER": "REPEATED_ORDER",
  /**
   * value: "INSUFFICIENT_BALANCE"
   * @const
   */
  "INSUFFICIENT_BALANCE": "INSUFFICIENT_BALANCE",
  /**
   * value: "PAYMENT_UNSUCCESSFUL"
   * @const
   */
  "PAYMENT_UNSUCCESSFUL": "PAYMENT_UNSUCCESSFUL",
  /**
   * value: "CARDDETAILS_INVALID"
   * @const
   */
  "CARDDETAILS_INVALID": "CARDDETAILS_INVALID",
  /**
   * value: "REFUND_UNSUCCESSFUL"
   * @const
   */
  "REFUND_UNSUCCESSFUL": "REFUND_UNSUCCESSFUL",
  /**
   * value: "SUBSCRIBER_NO_INFORMATION"
   * @const
   */
  "SUBSCRIBER_NO_INFORMATION": "SUBSCRIBER_NO_INFORMATION",
  /**
   * value: "ACCOUNT_LINK"
   * @const
   */
  "ACCOUNT_LINK": "ACCOUNT_LINK",
  /**
   * value: "ACCOUNT_LOCKED"
   * @const
   */
  "ACCOUNT_LOCKED": "ACCOUNT_LOCKED",
  /**
   * value: "MESSAGE_TEMPLATE_INVALID"
   * @const
   */
  "MESSAGE_TEMPLATE_INVALID": "MESSAGE_TEMPLATE_INVALID",
  /**
   * value: "EMAIL_REQUIRED"
   * @const
   */
  "EMAIL_REQUIRED": "EMAIL_REQUIRED",
  /**
   * value: "DISPLAY_SYMBOL_POSITION_MISSING"
   * @const
   */
  "DISPLAY_SYMBOL_POSITION_MISSING": "DISPLAY_SYMBOL_POSITION_MISSING",
  /**
   * value: "DISPLAY_MULTIPLE_MISSING"
   * @const
   */
  "DISPLAY_MULTIPLE_MISSING": "DISPLAY_MULTIPLE_MISSING",
  /**
   * value: "DISCONNECTED"
   * @const
   */
  "DISCONNECTED": "DISCONNECTED",
  /**
   * value: "NO_DEVICE_EXISTS"
   * @const
   */
  "NO_DEVICE_EXISTS": "NO_DEVICE_EXISTS",
  /**
   * value: "FILTER_NOT_VALID"
   * @const
   */
  "FILTER_NOT_VALID": "FILTER_NOT_VALID",
  /**
   * value: "ACCESS_CONTROL"
   * @const
   */
  "ACCESS_CONTROL": "ACCESS_CONTROL",
  /**
   * value: "PERSISTENCE"
   * @const
   */
  "PERSISTENCE": "PERSISTENCE",
  /**
   * value: "DUPLICATE_TAGS"
   * @const
   */
  "DUPLICATE_TAGS": "DUPLICATE_TAGS",
  /**
   * value: "PRODUCT_NOT_FOUND"
   * @const
   */
  "PRODUCT_NOT_FOUND": "PRODUCT_NOT_FOUND",
  /**
   * value: "DUPLICATE_PRODUCT_LEGACY_IDS"
   * @const
   */
  "DUPLICATE_PRODUCT_LEGACY_IDS": "DUPLICATE_PRODUCT_LEGACY_IDS",
  /**
   * value: "FILTER_ERROR"
   * @const
   */
  "FILTER_ERROR": "FILTER_ERROR",
  /**
   * value: "PAYMENT_PREFERENCES"
   * @const
   */
  "PAYMENT_PREFERENCES": "PAYMENT_PREFERENCES",
  /**
   * value: "BUSINESSES_NOT_FOUND"
   * @const
   */
  "BUSINESSES_NOT_FOUND": "BUSINESSES_NOT_FOUND",
  /**
   * value: "BUSINESS_NOT_FOUND"
   * @const
   */
  "BUSINESS_NOT_FOUND": "BUSINESS_NOT_FOUND",
  /**
   * value: "EMPLOYEES_NOT_FOUND"
   * @const
   */
  "EMPLOYEES_NOT_FOUND": "EMPLOYEES_NOT_FOUND",
  /**
   * value: "OPERATOR_NOT_FOUND"
   * @const
   */
  "OPERATOR_NOT_FOUND": "OPERATOR_NOT_FOUND",
  /**
   * value: "CUSTOMERS_NOT_FOUND"
   * @const
   */
  "CUSTOMERS_NOT_FOUND": "CUSTOMERS_NOT_FOUND",
  /**
   * value: "CUSTOMER_NOT_FOUND"
   * @const
   */
  "CUSTOMER_NOT_FOUND": "CUSTOMER_NOT_FOUND",
  /**
   * value: "LEVELS_NOT_FOUND"
   * @const
   */
  "LEVELS_NOT_FOUND": "LEVELS_NOT_FOUND",
  /**
   * value: "GROUPS_NOT_FOUND"
   * @const
   */
  "GROUPS_NOT_FOUND": "GROUPS_NOT_FOUND",
  /**
   * value: "OUTBOUNDCOMM_INVALID"
   * @const
   */
  "OUTBOUNDCOMM_INVALID": "OUTBOUNDCOMM_INVALID",
  /**
   * value: "TROUBLETICKET_INVALID"
   * @const
   */
  "TROUBLETICKET_INVALID": "TROUBLETICKET_INVALID",
  /**
   * value: "MUST_CHANGE_PASSOWRD"
   * @const
   */
  "MUST_CHANGE_PASSOWRD": "MUST_CHANGE_PASSOWRD",
  /**
   * value: "REGISTRATION_INCOMPLETE"
   * @const
   */
  "REGISTRATION_INCOMPLETE": "REGISTRATION_INCOMPLETE",
  /**
   * value: "LICENSE_KEY_INVALID"
   * @const
   */
  "LICENSE_KEY_INVALID": "LICENSE_KEY_INVALID",
  /**
   * value: "API_LICENSE_KEY_INVALID"
   * @const
   */
  "API_LICENSE_KEY_INVALID": "API_LICENSE_KEY_INVALID",
  /**
   * value: "API_CLIENT_VERSION_NOT_SUPPORTED"
   * @const
   */
  "API_CLIENT_VERSION_NOT_SUPPORTED": "API_CLIENT_VERSION_NOT_SUPPORTED",
  /**
   * value: "UNSUPPORTED_CALL_IN_THIS_VERSION"
   * @const
   */
  "UNSUPPORTED_CALL_IN_THIS_VERSION": "UNSUPPORTED_CALL_IN_THIS_VERSION",
  /**
   * value: "ACCOUNT_MICROSERVICE_ERROR"
   * @const
   */
  "ACCOUNT_MICROSERVICE_ERROR": "ACCOUNT_MICROSERVICE_ERROR",
  /**
   * value: "BALANCE_MICROSERVICE_ERROR"
   * @const
   */
  "BALANCE_MICROSERVICE_ERROR": "BALANCE_MICROSERVICE_ERROR",
  /**
   * value: "CATALOG_MANAGER_MICROSERVICE_ERROR"
   * @const
   */
  "CATALOG_MANAGER_MICROSERVICE_ERROR": "CATALOG_MANAGER_MICROSERVICE_ERROR",
  /**
   * value: "CONFIG_MANAGER_MICROSERVICE_ERROR"
   * @const
   */
  "CONFIG_MANAGER_MICROSERVICE_ERROR": "CONFIG_MANAGER_MICROSERVICE_ERROR",
  /**
   * value: "CONTENT_MANAGER_MICROSERVICE_ERROR"
   * @const
   */
  "CONTENT_MANAGER_MICROSERVICE_ERROR": "CONTENT_MANAGER_MICROSERVICE_ERROR",
  /**
   * value: "CUSTOMER_MICROSERVICE_ERROR"
   * @const
   */
  "CUSTOMER_MICROSERVICE_ERROR": "CUSTOMER_MICROSERVICE_ERROR",
  /**
   * value: "GUEST_USER_MICROSERVICE_ERROR"
   * @const
   */
  "GUEST_USER_MICROSERVICE_ERROR": "GUEST_USER_MICROSERVICE_ERROR",
  /**
   * value: "INVOICE_MICROSERVICE_ERROR"
   * @const
   */
  "INVOICE_MICROSERVICE_ERROR": "INVOICE_MICROSERVICE_ERROR",
  /**
   * value: "INVOICE_PDF_MICROSERVICE_ERROR"
   * @const
   */
  "INVOICE_PDF_MICROSERVICE_ERROR": "INVOICE_PDF_MICROSERVICE_ERROR",
  /**
   * value: "ORDER_MICROSERVICE_ERROR"
   * @const
   */
  "ORDER_MICROSERVICE_ERROR": "ORDER_MICROSERVICE_ERROR",
  /**
   * value: "ORG_MANAGER_MICROSERVICE_ERROR"
   * @const
   */
  "ORG_MANAGER_MICROSERVICE_ERROR": "ORG_MANAGER_MICROSERVICE_ERROR",
  /**
   * value: "OUTBOUNDCOMMS_MICROSERVICE_ERROR"
   * @const
   */
  "OUTBOUNDCOMMS_MICROSERVICE_ERROR": "OUTBOUNDCOMMS_MICROSERVICE_ERROR",
  /**
   * value: "PAYMENT_MICROSERVICE_ERROR"
   * @const
   */
  "PAYMENT_MICROSERVICE_ERROR": "PAYMENT_MICROSERVICE_ERROR",
  /**
   * value: "PLATFORM_ANALYTICS_MICROSERVICE_ERROR"
   * @const
   */
  "PLATFORM_ANALYTICS_MICROSERVICE_ERROR": "PLATFORM_ANALYTICS_MICROSERVICE_ERROR",
  /**
   * value: "SERVICE_MICROSERVICE_ERROR"
   * @const
   */
  "SERVICE_MICROSERVICE_ERROR": "SERVICE_MICROSERVICE_ERROR",
  /**
   * value: "ADAPTOR_ERROR"
   * @const
   */
  "ADAPTOR_ERROR": "ADAPTOR_ERROR",
  /**
   * value: "ORDER_FAILED"
   * @const
   */
  "ORDER_FAILED": "ORDER_FAILED",
  /**
   * value: "PROPERTIES_FILE_INVALID"
   * @const
   */
  "PROPERTIES_FILE_INVALID": "PROPERTIES_FILE_INVALID",
  /**
   * value: "ORDER_ITEM"
   * @const
   */
  "ORDER_ITEM": "ORDER_ITEM",
  /**
   * value: "OPERATOR_NOT_RECOGNIZED"
   * @const
   */
  "OPERATOR_NOT_RECOGNIZED": "OPERATOR_NOT_RECOGNIZED",
  /**
   * value: "GATEWAY_NOT_RECOGNIZED"
   * @const
   */
  "GATEWAY_NOT_RECOGNIZED": "GATEWAY_NOT_RECOGNIZED",
  /**
   * value: "PAYONINVOICE_INVALID"
   * @const
   */
  "PAYONINVOICE_INVALID": "PAYONINVOICE_INVALID",
  /**
   * value: "PAYINSTORECASH_INVALID"
   * @const
   */
  "PAYINSTORECASH_INVALID": "PAYINSTORECASH_INVALID",
  /**
   * value: "FILE_INVALID"
   * @const
   */
  "FILE_INVALID": "FILE_INVALID",
  /**
   * value: "NO_SUB_CATALOG_EXISTS"
   * @const
   */
  "NO_SUB_CATALOG_EXISTS": "NO_SUB_CATALOG_EXISTS",
  /**
   * value: "NO_CATALOG_EXISTS"
   * @const
   */
  "NO_CATALOG_EXISTS": "NO_CATALOG_EXISTS",
  /**
   * value: "UNKNOWN_PRODUCT_TYPE"
   * @const
   */
  "UNKNOWN_PRODUCT_TYPE": "UNKNOWN_PRODUCT_TYPE",
  /**
   * value: "TECHOFFER_INVALID"
   * @const
   */
  "TECHOFFER_INVALID": "TECHOFFER_INVALID",
  /**
   * value: "NO_PRODUCT_EXISTS"
   * @const
   */
  "NO_PRODUCT_EXISTS": "NO_PRODUCT_EXISTS",
  /**
   * value: "NULL_OR_EMPTY"
   * @const
   */
  "NULL_OR_EMPTY": "NULL_OR_EMPTY",
  /**
   * value: "RULE_NO_LEGACY_ID"
   * @const
   */
  "RULE_NO_LEGACY_ID": "RULE_NO_LEGACY_ID",
  /**
   * value: "RULE_MULTIPLE_PRODUCTS"
   * @const
   */
  "RULE_MULTIPLE_PRODUCTS": "RULE_MULTIPLE_PRODUCTS",
  /**
   * value: "DATA_ERROR"
   * @const
   */
  "DATA_ERROR": "DATA_ERROR",
  /**
   * value: "MASTER_CATALOG_MISSING"
   * @const
   */
  "MASTER_CATALOG_MISSING": "MASTER_CATALOG_MISSING",
  /**
   * value: "CATALOG_ERROR"
   * @const
   */
  "CATALOG_ERROR": "CATALOG_ERROR",
  /**
   * value: "ROLE_INVALID"
   * @const
   */
  "ROLE_INVALID": "ROLE_INVALID"
};
var _default = exports["default"] = Message;